import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Card, message, Popconfirm, Table } from "antd";
import { Link, Outlet, useNavigate } from "react-router-dom";
import ContentWithErrorHandler from "../../app/ContentWithErrorHandler";
import { basicSort } from "../../common/TableHelper";
import { useDeleteQuestionaireResultConfigMutation, useGetAllQuestionaireResultConfigQuery } from "./financialLiteracyAPI";

function FinancialLiteracyQuestionResultConfigList() {
  const navigate = useNavigate();
  const { data, error, isLoading } = useGetAllQuestionaireResultConfigQuery();
  const [deleteQuestionaire] = useDeleteQuestionaireResultConfigMutation();

  return (
    <ContentWithErrorHandler isError={error} isLoading={false}>
      <Card
        title="Pengaturan Hasil Kuisioner"
        size="small"
        extra={
          <div>
            <Button style={{ borderRadius: 5 }}>
              <Link to="create">+ Tambah Baris</Link>
            </Button>
          </div>
        }
      >
        <Table
          loading={isLoading}
          dataSource={data}
          bordered
          size="small"
          pagination={{ pageSize: 15 }}
          columns={[
            {
              title: "ID",
              dataIndex: "id",
              key: "id",
              sorter: (a, b) => basicSort(a.id, b.id),
              width: "5%",
            },
            {
              title: "Tipe",
              dataIndex: "type",
              key: "type",
              width: "10%",
            },
            {
              title: "Operator",
              dataIndex: "sign",
              key: "sign",
              width: "15%",
            },
            {
              title: "Nilai 1",
              dataIndex: "value1",
              key: "value1",
              width: "10%",
            },
            {
              title: "Nilai 2",
              dataIndex: "value2",
              key: "value2",
              width: "10%",
            },
            {
              title: "Teks",
              dataIndex: "description",
              key: "description",
              width: "40%",
            },
            {
              title: "Aksi",
              key: "x",
              width: "10%",
              render: (text, record) => (
                <div>
                  <Button type="link" icon={<EditOutlined />} style={{ borderRadius: 5 }} onClick={() => navigate(`detail/${record.id}`)} />
                  <Popconfirm
                    title="Apakah anda yakin?"
                    onConfirm={() => {
                      const hideLoading = message.loading("Loading", 0);
                      deleteQuestionaire(record.id)
                        .unwrap()
                        .then(() => {
                          hideLoading();
                          message.success("Berhasil!");
                        })
                        .catch(() => {
                          hideLoading();
                          message.error("Gagal!");
                        });
                    }}
                    okText="Hapus"
                    cancelText="Batal"
                  >
                    <Button type="link" danger icon={<DeleteOutlined />} style={{ borderRadius: 5 }} />
                  </Popconfirm>
                </div>
              ),
            },
          ]}
        />
      </Card>
      <Outlet />
    </ContentWithErrorHandler>
  );
}

export default FinancialLiteracyQuestionResultConfigList;
